import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { handleFundsecurelist, MarkAsCompleted, usTimezone } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row, Button } from 'react-bootstrap';
import moment from 'moment';
import Loaderspinner from "../../components/Loader";
import { toast } from "react-toastify";
import { Tooltip } from 'react-tooltip'

const FundSecureList = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [fundSecureList, setFundsecureList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  let isMarked = localStorage.getItem('role')

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const fetchFundSecurelist = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      const limit = 10;
      const offset = page * limit;

      const response = await handleFundsecurelist({
        limit,
        offset,
        token,
      });

      setFundsecureList(response?.data || []);

      if ((response?.data?.length || 0) < limit) {
        setTotalPages(page + 1);
      } else {
        setTotalPages(page + 2);
      }

    } catch (error) {
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchFundSecurelist();
  }, [page]);


  return (
    <>
      {loading && <Loaderspinner />}
      <div className="g-sidenav-show bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>Funded Projects</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row">
                          <h5 className="mb-0 w-auto">Funded Projects </h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="Displays projects where funding has been successfully secured. Coordinators should mark these as complete and ensure all post-funding processes are properly followed"
                            data-tooltip-place="right"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Project Name</th>
                            <th>Created At</th>
                            <th>Capital Partner</th>
                            <th>Investment Type</th>
                            <th>Location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fundSecureList?.length > 0 ? (
                            fundSecureList.map((project, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-flex flex-row align-items-center" style={{ width: "auto" }}>
                                    <Link to={`/view-project/${project?.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View Project</span>
                                      </button>
                                    </Link>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.funder?.about?.name} {project?.funder?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.project_name}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div style={{ width: "120px" }}><span>{usTimezone(project?.created_at)}</span></div>
                                </td>

                                <td className="table-user">
                                  {project?.capital_partner === "MultiFamily" ?
                                    <div style={{ width: "120px" }}>
                                      <span>Multi Family</span>
                                    </div> : project?.capital_partner === "SingleFamily" ?
                                      <div style={{ width: "120px" }}>
                                        <span>Single Family</span>
                                      </div> :
                                      <div style={{ width: "120px" }}>
                                        <span>{project?.capital_partner ? project?.capital_partner : ""}</span>
                                      </div>
                                  }

                                </td>

                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.funder?.about?.invest_type}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div>
                                    <div className="">{project?.funder?.about?.city && project?.funder?.about?.county ? `${project?.funder?.about?.city}, ${project?.funder?.about?.county}` : project?.funder?.about?.city}</div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
        </div>
      </div>

    </>

  )
}
export default FundSecureList;